<template>
    <modal name="message-modal" :adaptive="true" :height="'auto'" @before-open="onModalShow">
        <div class="row">
            <div class="col-12">
                <div class="card" v-if="message">
                    <div class="card-header">
                        Dettaglio messaggio
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Oggetto</label>
                                    <input :readonly="message.id" type="text" name="message-title" v-model="message.title" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Contenuto messaggio</label>
                                    <textarea :readonly="message.id" rows="5" name="message-content" v-model="message.content" class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                         <div class="row" v-if="!message.id">
                            <div class="col">
                                <div class="form-group">
                                    <label>Tipologia</label>
                                    <select class="form-control" v-model="message.type">
                                        <option :value="null" disabled>-- Seleziona una tipologia --</option>
                                        <option v-for="(type, i) in types" :key="i" :value="type.value">
                                            {{ type.value }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="!message.id && currentUser.type === 1">
                            <div class="col">
                                <div class="form-group">
                                    <label>Destinatario</label>
                                    <select class="form-control" v-model="message.created_to">
                                        <option :value="null" disabled>-- Seleziona un utente --</option>
                                        <option value="all">Broadcast (tutti gli utenti)</option>
                                        <option v-for="(user, i) in computedUsers" :key="i" :value="user.value">
                                            {{ user.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="message.creator && message.receiver">
                            <div class="col text-right">
                                Da <strong>{{ message.creator.email }}</strong> a <strong>{{ message.receiver.email }}</strong>
                            </div>
                        </div>
                        <div class="row mt-2" v-if="message.id">
                            <div class="col">
                                <label><b>Risposta rapida</b></label>
                                <textarea class="form-control" rows="5" v-model="reply.content">

                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div v-if="$v.message.$error" class="alert alert-danger mb-3">
                            <span v-if="!$v.message.title.required">Un titolo è richiesto.<br></span>
                            <span v-if="!$v.message.content.required">Un contenuto è richiesto.<br></span>
                            <span v-if="!$v.message.type.required">Una tipologia è richiesta.<br></span>
                        </div>
                        <div v-if="$v.reply.$error" class="alert alert-danger mb-0">
                            <span v-if="!$v.reply.content.required">Un contenuto è richiesto.<br></span>
                        </div>
                        <button v-if="message.id" type="submit" class="btn btn-success" @click="replyToMessage">
                            <font-awesome-icon icon="arrow-up" size="sm"></font-awesome-icon>&nbsp;RISPONDI
                        </button>
                        <button v-else type="submit" class="btn btn-success" @click="insertMessage">
                            <font-awesome-icon icon="arrow-up" size="sm"></font-awesome-icon>&nbsp;AGGIUNGI
                        </button>
                        <button type="button" class="btn btn-light" @click="closeModal">
                            <font-awesome-icon icon="times"></font-awesome-icon>&nbsp;CHIUDI
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import {
    required
} from 'vuelidate/lib/validators'
import {
    Message
} from '@/models/Message'
import {
    mapGetters
} from 'vuex'
import {} from 'vuelidate/lib/validators'
import {
    GET_LIST,
    CREATE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/messages.module'
import {
    MODULE_NAME as USERS_MODULE_NAME
} from '@/store/modules/users.module'
const TYPES = [{
    value: 'BUG'
},
{
    value: 'RICHIESTA INFORMAZIONI'
},
{
    value: 'CIRCOLARE'
},
{
    value: 'SEGNALAZIONE GENERICA'
},
{
    value: 'AVVISO'
}
]
export default {
    name: 'message-modal',
    props: {
        message: {
            default: new Message(),
            type: Object
        }
    },
    data () {
        return {
            types: TYPES,
            reply: new Message()
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            users: `${USERS_MODULE_NAME}/getList`
        }),
        computedUsers () {
            var _users = []
            if (this.users.data) {
                let allUsers = this.users.data
                for (var i = 0; i < allUsers.length; i++) {
                    var type = allUsers[i].type === 1 ? 'Admin' : allUsers[i].type === 2 ? 'User' : 'Group'
                    var u = {
                        value: allUsers[i].id,
                        text: allUsers[i].email + ' (' + type + ')'
                    }
                    if (allUsers[i].id !== this.currentUser.id) _users.push(u)
                }
            }
            return _users
        }
    },
    validations: {
        reply: {
            content: {
                required
            }
        },
        message: {
            title: {
                required
            },
            content: {
                required
            },
            type: {
                required
            }
        }
    },
    methods: {
        closeModal () {
            this.$modal.hide('message-modal')
        },
        fetchUsers () {
            this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_LIST}`, {
                query: {}
            })
        },
        onModalShow () {
            // Resetto il validatore
            this.$v.$reset()
            let isOldMessage = this.message.id
            this.reply = new Message()
            // Imposto lo status del messaggio a 1 (letto)
            // if (this.message.status === 0 && isOldMessage) {
            //     this.message.status = 1
            //     this.$store.dispatch(`${MODULE_NAME}/${UPDATE}`, this.message)
            // }
            // Se è un nuovo messaggio, carico la lista dei possibili destinatari (solo per admin)
            if (!isOldMessage && this.currentUser.type === 1) this.fetchUsers()
        },
        replyToMessage () {
            this.$v.reply.$touch()
            if (!this.$v.reply.$invalid) {
                let resp = new Message(this.reply)
                resp.created_to = this.message.created_from
                resp.ref = this.message.id
                resp.type = 'REPLY'
                resp.title = `REPLY TO "${this.message.title}"`
                this.$store.dispatch(`${MODULE_NAME}/${CREATE}`,
                    resp
                ).then(() => {
                    this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                        query: {}
                    })
                    this.closeModal()
                })
            }
        },
        insertMessage () {
            // Forzo il destinatario a id admin (1) !!!! DA SISTEMARE !!!
            this.$v.message.$touch()
            if (!this.$v.message.$invalid) {
                // if (!this.message.created_to) this.message.created_to = 1
                this.$store.dispatch(`${MODULE_NAME}/${CREATE}`,
                    this.message
                ).then(() => {
                    this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                        query: {}
                    })
                    this.closeModal()
                })
            }
        }
    }
}
</script>
